import { createBrowserHistory as createHistory } from 'history';

// @cc: basename: context path + /web
const history = createHistory({ basename: `${process.env.REACT_APP_BASENAME || ''}` });
export default history;
